const initState = {
  user: [],
  allUsers: [],
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_USERS":
      return {
        ...state,
        user: action.payload,
      };
    case "GET_ALL_USERS":
      return {
        ...state,
        allUsers: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default userReducer;
